<div
  class="sidenav-content d-flex flex-column"
  [ngClass]="{ menu__hiding: !showSidenavControls, menu__showing: showSidenavControls }"
  (mouseleave)="showSidenav(false)"
  (mouseenter)="showSidenav(true)"
>
  <div class="sidenav-features">
    @for (app of customerApps; track app.addonName) {
      <nav class="sidenav-portal">
        <div class="sf__item" [class.portal-active]="isPortalActive(app)">
          <button
            type="button"
            class="sf__action"
            (click)="onCustomerPortalClickedEmit({ app })"
            (keydown)="onPortalKeydown($event, app)"
            [attr.data-testid]="'customer-portal-' + app.addonName + '-selector--collapsed'"
          >
            <img
              src="../../../../../assets/images/icons/{{ app.icon }}"
              width="28px"
              class="mr-3"
              [ngClass]="{ 'only-icon': !showSidenavControls, 'ml-1': showSidenavControls }"
              [alt]="app.name + ' Icon'"
            />
            @if (showSidenavControls) {
              <p class="text-left">{{ app.name }}</p>
            }
            @if (showSidenavControls && app.isExternal) {
              <img
                src="../../../../../assets/images/icons/redirect-icon-white.svg"
                width="15px"
                class="ml-auto mr-2 mb-1 redirect"
                alt="Redirect Icon"
              />
            }
          </button>
          @if (showSidenavControls && hasPortalSubmenus(app)) {
            <button
              type="button"
              class="sf__toggle"
              (click)="onTogglePortalClick($event, app)"
              (keydown)="onTogglePortalKeydown($event, app)"
              [attr.aria-label]="getPortalToggleAriaLabel(app)"
              [attr.aria-expanded]="isPortalExpanded(app)"
            >
              <mat-icon class="sf__toggle-icon" aria-hidden="true">
                {{ isPortalExpanded(app) ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </button>
          }
        </div>
        <!-- Submenus Section -->
        @if (showSidenavControls && hasPortalSubmenus(app)) {
          <div class="sidenav-portal__submenus" [@expandCollapse]="isPortalExpanded(app) ? 'expanded' : 'collapsed'">
            @if (isPortalExpanded(app)) {
              <ng-container *ngTemplateOutlet="renderSubmenus; context: { $implicit: app.submenus, level: 0 }">
              </ng-container>
            }
          </div>
        }
      </nav>
    }
  </div>
</div>

<div
  style="height: 100%"
  [ngStyle]="{ width: showSidenavControls ? '70px' : '70px', 'min-width': showSidenavControls ? '70px' : '70px' }"
></div>

<ng-template #renderSubmenus let-submenus let-level="level">
  @if (submenus && submenus.length) {
    <div class="submenus-container" [class.submenus-container--nested]="level > 0">
      @for (submenu of submenus; track submenu.id) {
        <div
          class="submenu__item"
          [class.submenu-active]="isSubmenuActive(submenu)"
          [style.padding-left.px]="getSubmenuPadding(level)"
        >
          <button
            type="button"
            class="submenu__action"
            (click)="onSubmenuClicked(submenu)"
            (keydown)="onSubmenuKeydown($event, submenu)"
            [attr.data-testid]="'submenu-' + submenu.id + '-selector--collapsed'"
          >
            <span class="submenu__label">{{ submenu.name }}</span>
          </button>
          @if (hasSubmenus(submenu)) {
            <button
              type="button"
              class="submenu__toggle"
              (click)="onToggleSubmenuClick($event, submenu)"
              (keydown)="onToggleSubmenuKeydown($event, submenu)"
              [attr.aria-label]="getToggleAriaLabel(submenu)"
              [attr.aria-expanded]="isSubmenuExpanded(submenu)"
            >
              <mat-icon class="submenu__toggle-icon">
                {{ isSubmenuExpanded(submenu) ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </button>
          }
        </div>
        @if (hasSubmenus(submenu)) {
          <div class="submenu__collapse" [@expandCollapse]="isSubmenuExpanded(submenu) ? 'expanded' : 'collapsed'">
            @if (isSubmenuExpanded(submenu)) {
              <ng-container
                *ngTemplateOutlet="renderSubmenus; context: { $implicit: submenu.submenus, level: level + 1 }"
              >
              </ng-container>
            }
          </div>
        }
      }
    </div>
  }
</ng-template>
